import { useEffect, useState } from "react";
import { client, urlFor } from "../lib/sanity";
import { useTranslation } from "react-i18next";
import "./Fastigheter.css";

export default function SoldFastigheter() {
    const [fastigheter, setFastigheter] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        client
            .fetch(`*[_type == "property" && sold == true] | order(_createdAt desc){
                ...,
                "images": images[]{
                    asset->{
                        _id,
                        url
                    }
                }
            }`)
            .then(setFastigheter)
            .catch(console.error);
    }, []);

    return (
        <section className="mag-list-section sold-archive-page">
            <div className="mag-container">

                <header className="mag-list-header">
                    <span className="mag-label">{t("archive")}</span>
                    <h1 className="mag-list-title">{t("soldProperties")}</h1>
                    <p className="mag-list-intro">
                        En tillbakablick på några av de hem vi haft förmånen att förmedla.
                    </p>
                </header>

                <div className="mag-main-grid">
                    {fastigheter.map((f) => {
                        const displayPrice = f.finalPrice || f.price;

                        return (
                            <div key={f._id} className="mag-card is-sold">
                                <div className="mag-card-image-wrapper overlay-sold">
                                    {f.images?.[0] && (
                                        <img
                                            src={urlFor(f.images[0]).width(800).url()}
                                            alt={f.address}
                                            loading="lazy"
                                        />
                                    )}
                                    <div className="mag-status-tags">
                                        <span className="tag sold-tag">{t("sold")}</span>
                                    </div>
                                </div>

                                <div className="mag-card-content">
                                    <span className="mag-card-city-label">{f.city}</span>
                                    <h3 className="mag-card-address">{f.address}</h3>
                                    <div className="mag-card-details-group">

                                        {f.rooms && (
                                            <span className="mag-detail">{f.rooms} {t("rooms")}</span>
                                        )}

                                        {f.livingArea && (
                                            <>
                                                {f.rooms && <span className="mag-sep">/</span>}
                                                <span className="mag-detail">{f.livingArea} m²</span>
                                            </>
                                        )}

                                        {displayPrice && (
                                            <>
                                                {(f.rooms || f.livingArea) && <span className="mag-sep">/</span>}
                                                <span className="mag-card-price">
                                                    {Number(displayPrice).toLocaleString("sv-SE")} SEK
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}